<script setup lang="ts">
import MessageBox from '@/components/MessageBox.vue'

defineProps<{
  message: string
}>()
</script>

<template>
  <MessageBox data-test="error-box" :message="message" type="error" />
</template>
